import React from 'react'
import PhysiotherapyDrawer from '../../components/drawers/physiotherapy'
import BilledQueue from '../../components/pages/billedQueue'

const Queue = () => {
    return <BilledQueue category="Physiotherapy" basePath="/app/physiotherapy/queue" DrawerComponent={PhysiotherapyDrawer} />
}

export default Queue
